// extracted by mini-css-extract-plugin
module.exports = {"hero":"Gallery_hero__s0byV","thumbnail":"Gallery_thumbnail__f0UJQ","container":"Gallery_container____TOE"};